import { render } from "./emoji-picker.vue?vue&type=template&id=649e31c6"
import script from "./emoji-picker.vue?vue&type=script&lang=js"
export * from "./emoji-picker.vue?vue&type=script&lang=js"

import "./emoji-picker.vue?vue&type=style&index=0&id=649e31c6&lang=css"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__